import { render, staticRenderFns } from "./CopiedBlock.htm?vue&type=template&id=77059860&scoped=true&"
import script from "./CopiedBlock.js?vue&type=script&lang=js&"
export * from "./CopiedBlock.js?vue&type=script&lang=js&"
import style0 from "./CopiedBlock.scss?vue&type=style&index=0&id=77059860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77059860",
  null
  
)

export default component.exports